import React, { useEffect, useState } from "react";
import { Table, Tag, Button } from "antd";
import { useLoading } from "../../../context/loadingContext";
import dayjs from "dayjs";
import GetMerchantSettle from "../../../functions/merchant/getMerchantSettle";
import CalculatePercent from "../../../functions/utils/calculatePercent";
import moneyFormat from "../../../functions/utils/moneyFormat";
import { EyeFilled } from "@ant-design/icons";
import SettleTransactions from "../../../components/modal/settleTransactions";
import { useMerchant } from "../../../context/merchantContext";
import SearchDatePickerIncome from "../../../components/search/datePickerIncome";
import TablePagination from "components/pagination/tablePagination";
import { bg_shadow } from "constant/css";

const MerchantSettlements = ({ activeMerchantId = null }) => {
  const { showLoading, hideLoading } = useLoading();
  const { searchFieldsIncome } = useMerchant();
  const [data, setData] = useState([]);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(5);
  const [paginationData, setPaginationData] = useState({});
  const [showTransactions, setShowTransactions] = useState(null);
  const [settleSettledAt, setSettleSettledAt] = useState(null);

  useEffect(() => {
    prepareQueryStringAndSearch();
    // eslint-disable-next-line
  }, [searchFieldsIncome, page, pageSize]);

  const prepareQueryStringAndSearch = () => {
    const searchFieldsLength = Object.keys(searchFieldsIncome).length;
    let queryString = "";
    if (searchFieldsLength !== 0) {
      queryString = Object.keys(searchFieldsIncome)
        .map((key) => {
          if (!searchFieldsIncome[key]) return "";
          if (key.includes("At")) {
            return `${key}=${searchFieldsIncome[key]
              .map((e, i) => {
                if (i === 0)
                  return dayjs(e).startOf("day").format("YYYY-MM-DD HH:MM");
                return dayjs(e).endOf("day").format("YYYY-MM-DD HH:MM");
              })
              .join("->")}`;
          }
          return `${key}=${encodeURIComponent(searchFieldsIncome[key])}`;
        })
        .join("&");
      fetchInvoices(queryString, page, pageSize);
    }
  };

  const columns = [
    {
      title: "#",
      dataIndex: "id",
      key: "id",
      fixed: "left",
      width: 20,
      className: "text-xs",
    },
    {
      title: "Нийт дүн",
      dataIndex: "amount",
      key: "amount",
      width: 50,
      render: (e) => <span className="text-xs">{moneyFormat(e)}₮</span>,
      className: "text-xs",
    },
    {
      title: "Tоо/ш",
      dataIndex: "count",
      key: "count",
      width: 50,
      render: (e) => <span className="text-xs">{e}</span>,
      className: "text-xs",
    },
    {
      title: "Шимтгэл",
      dataIndex: "feePercent",
      key: "feePercent",
      width: 50,
      render: (e) => <span className="text-xs">{e ? e + "%" : "-"}</span>,
      className: "text-xs",
    },
    {
      title: "Авах дүн",
      dataIndex: "feePercent",
      key: "feePercent",
      width: 50,
      render: (e, r) => (
        <span className="text-xs">
          {moneyFormat(CalculatePercent(r.amount, e))}₮
        </span>
      ),
      className: "text-xs",
    },
    {
      title: "СмартБиллинг шимтгэл",
      dataIndex: "spayFeePercent",
      key: "spayFeePercent",
      width: 50,
      render: (e) => <span className="text-xs">{e ? e + "%" : "-"}</span>,
      className: "text-xs",
    },
    {
      title: "Смарт Биллинг авах дүн",
      dataIndex: "spayFeePercent",
      key: "spayFeePercent",
      width: 50,
      render: (e, r) => (
        <span className="text-xs">
          {moneyFormat(CalculatePercent(r.amount, e))}₮
        </span>
      ),
      className: "text-xs",
    },

    {
      title: (
        <SearchDatePickerIncome
          title="Үүссэн огноо"
          datePicker
          fieldName="createdAt"
        />
      ),
      dataIndex: "createdAt",
      key: "createdAt",
      width: 120,
      render: (e) => (
        <span className="text-xs">
          {e ? dayjs(e).format("YYYY-MM-DD") : "-"}
        </span>
      ),
      className: "text-xs",
    },
    {
      title: "Төрөл",
      dataIndex: "settledType",
      key: "settledType",
      width: 50,
      render: (e) => <span className="text-xs">{e || "-"}</span>,
      className: "text-xs",
    },
    {
      title: "Төлөв",
      dataIndex: "status",
      key: "status",
      width: 50,
      render: (e) =>
        e === "SETTLED" ? (
          <Tag color="cyan" className="text-xs px-1 py-0.5">
            Өндөрлөсөн
          </Tag>
        ) : e === "ACTIVE" ? (
          <Tag color="blue" className="text-xs px-1 py-0.5">
            Идэвхтэй
          </Tag>
        ) : (
          <Tag color="default" className="text-xs px-1 py-0.5">
            Идэвхгүй
          </Tag>
        ),
      className: "text-xs",
    },
    {
      title: "",
      dataIndex: "action",
      key: "action",
      fixed: "right",
      width: 30,
      render: (e, r) => (
        <div className="flex flex-row gap-1">
          <Button
            size="small"
            onClick={() => showDetail(r)}
            icon={<EyeFilled style={{ color: "green", fontSize: 14 }} />}
            className="p-0 h-6 w-6 flex items-center justify-center"
          />
        </div>
      ),
      className: "text-xs",
    },
  ];

  useEffect(() => {
    refresh();
    // eslint-disable-next-line
  }, [activeMerchantId]);

  const showDetail = (row) => {
    setSettleSettledAt(row?.settledAt || null);
    setShowTransactions(row?.id || null);
  };

  const fetchInvoices = async (queryString, page, size) => {
    showLoading();
    const merchantId = activeMerchantId;
    const response = await GetMerchantSettle(
      merchantId,
      `&page=${page}&size=5&${queryString}`
    );
    hideLoading();
    if (response) {
      setData(response.data);
      setPaginationData(response.pagination);
    } else setData([]);
  };

  const changePage = (page) => {
    setPage(page);
    fetchInvoices("", page, pageSize);
  };

  const changeSize = (current, size) => {
    setPageSize(size);
    fetchInvoices("", current, size);
  };

  const refresh = () => {
    setPage(1);
    fetchInvoices("", 1, pageSize);
  };

  const closeShowTransactions = () => {
    setShowTransactions(null);
    setSettleSettledAt(null);
  };

  return (
    <div
      className={`vatMerchantListontainer p-2 md:p-4 ${bg_shadow} rounded-xl`}
    >
      <div className="tableContainer">
        <Table
          columns={columns}
          rowKey={(record) => record.id}
          scroll={{
            x: "max-content",
            y: "calc(100vh - 48vh)",
          }}
          pagination={false}
          dataSource={data}
          size="small"
          className="text-xs"
        />
        <TablePagination
          page={page}
          paginationData={paginationData}
          changePage={changePage}
          changeSize={changeSize}
        />
      </div>
      {showTransactions && (
        <SettleTransactions
          open={showTransactions}
          refresh={refresh}
          close={closeShowTransactions}
          defaultMerchantId={activeMerchantId}
          settledAt={settleSettledAt}
        />
      )}
    </div>
  );
};

export default MerchantSettlements;
